<template>
  <v-card flat color="transparent" class="pt-3">
    <v-container>
      
      <v-card :elevation="elevation" outlined v-for="group in partners" :key="group.title" class="mb-1">
      <v-card-title class="justify-center secondary--text pb-0 mt-12">
        <h2 class="mb-0 headline-partner">{{ group.title }}</h2>
      </v-card-title>
      
      <v-item-group >
        <v-row class="justify-center">
          <v-col v-for="partner in group.partners" :key="partner.id" cols="auto" :class="$vuetify.breakpoint.smAndDown ? 'px-5' : 'px-9'">
            <PartnerItem v-bind:partner="partner" />
          </v-col>
        </v-row>
      </v-item-group>
      </v-card>
    </v-container>
  </v-card>
</template>

<script>
import PartnerItem from "./PartnerItem";

export default {
  components: {
    PartnerItem,
  },
  props: {
    headline: String,
    useEvent: {type:Boolean, value:false},
    elevation: {type: Number, value:1}
  },
  data: () => ({
    partners: [],
  }),
  async mounted() {
    this.partners = (await this.$axios.get(`api/partner/byTitle?useEvent=${this.useEvent}`)).data;    
  },
};
</script>

<style lang="scss" scoped>
.headline-partner{
  font-family: thin;
  // font-size: 1.5rem;
}
</style>